var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIc16X16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8574 2.84116C14.3582 2.37624 15.1579 2.38797 15.6436 2.86735C16.0851 3.30316 16.1151 3.97543 15.7407 4.44335L15.6162 4.57716L6.00482 13.5L0.336018 7.63544C-0.137779 7.14529 -0.106771 6.38026 0.405277 5.92672C0.870776 5.51441 1.57358 5.50146 2.05348 5.87078L2.19031 5.99302L6.1019 10.0403L13.8574 2.84116Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIc16X16);
export default __webpack_public_path__ + "static/media/check_ic_16x16.879dde2172e85cfc9646f1ed8d4bc11a.svg";
export { ForwardRef as ReactComponent };